export default {
  computed: {
    langCodes() {
      return [
        {
          label: this.$i18next.t('message.pages.videoEditModal.languages.portuguese'),
          srclang: 'pt-BR',
          country: 'br',
        },
        {
          label: this.$i18next.t('message.pages.videoEditModal.languages.english'),
          srclang: 'en',
          country: 'us',
        },
        {
          label: this.$i18next.t('message.pages.videoEditModal.languages.spanish'),
          srclang: 'es',
          country: 'es',
        },
        {
          label: this.$i18next.t('message.pages.videoEditModal.languages.french'),
          srclang: 'fr',
          country: 'fr',
        },
        {
          label: this.$i18next.t('message.pages.videoEditModal.languages.italian'),
          srclang: 'it',
          country: 'it',
        },
        {
          label: this.$i18next.t('message.pages.videoEditModal.languages.japanese'),
          srclang: 'ja',
          country: 'jp',
        },
        {
          label: this.$i18next.t('message.pages.videoEditModal.languages.russian'),
          srclang: 'ru',
          country: 'ru',
        },
        {
          label: this.$i18next.t('message.pages.videoEditModal.languages.vietnamese'),
          srclang: 'vi',
          country: 'vn',
        },
        {
          label: this.$i18next.t('message.pages.videoEditModal.languages.chineseSimplified'),
          srclang: 'zh',
          country: 'cn',
        },
        {
          label: this.$i18next.t('message.pages.videoEditModal.languages.arabian'),
          srclang: 'ar',
          country: 'sa',
        },
        {
          label: this.$i18next.t('message.pages.videoEditModal.languages.korean'),
          srclang: 'ko',
          country: 'kr',
        },
        {
          label: this.$i18next.t('message.pages.videoEditModal.languages.german'),
          srclang: 'de',
          country: 'de',
        },
        {
          label: this.$i18next.t('message.pages.videoEditModal.languages.hindi'),
          srclang: 'hi',
          country: 'in',
        },
        {
          label: this.$i18next.t('message.pages.videoEditModal.languages.thai'),
          srclang: 'th',
          country: 'th',
        },
        {
          label: this.$i18next.t('message.pages.videoEditModal.languages.turkish'),
          srclang: 'tr',
          country: 'tr',
        },
        {
          label: this.$i18next.t('message.pages.videoEditModal.languages.indonesian'),
          srclang: 'id',
          country: 'id',
        },
        {
          label: this.$i18next.t('message.pages.videoEditModal.languages.polish'),
          srclang: 'pl',
          country: 'pl',
        },
        {
          label: this.$i18next.t('message.pages.videoEditModal.languages.dutch'),
          srclang: 'nl',
          country: 'nl',
        },
        {
          label: this.$i18next.t('message.pages.videoEditModal.languages.swedish'),
          srclang: 'sv',
          country: 'se',
        },
        {
          label: this.$i18next.t('message.pages.videoEditModal.languages.norwegian'),
          srclang: 'no',
          country: 'no',
        },
        {
          label: this.$i18next.t('message.pages.videoEditModal.languages.romanian'),
          srclang: 'ro',
          country: 'ro',
        },
        {
          label: this.$i18next.t('message.pages.videoEditModal.languages.greek'),
          srclang: 'el',
          country: 'gr',
        },
        {
          label: this.$i18next.t('message.pages.videoEditModal.languages.czech'),
          srclang: 'cs',
          country: 'cz',
        },
        {
          label: this.$i18next.t('message.pages.videoEditModal.languages.hungarian'),
          srclang: 'hu',
          country: 'hu',
        },
        {
          label: this.$i18next.t('message.pages.videoEditModal.languages.malay'),
          srclang: 'ms',
          country: 'my',
        },
        {
          label: this.$i18next.t('message.pages.videoEditModal.languages.bulgarian'),
          srclang: 'bg',
          country: 'bg',
        },
        {
          label: this.$i18next.t('message.pages.videoEditModal.languages.finnish'),
          srclang: 'fi',
          country: 'fi',
        },
        {
          label: this.$i18next.t('message.pages.videoEditModal.languages.croatian'),
          srclang: 'hr',
          country: 'hr',
        },
        {
          label: this.$i18next.t('message.pages.videoEditModal.languages.slovak'),
          srclang: 'sk',
          country: 'sk',
        },
        {
          label: this.$i18next.t('message.pages.videoEditModal.languages.ukrainian'),
          srclang: 'uk',
          country: 'ua',
        },
        {
          label: this.$i18next.t('message.pages.videoEditModal.languages.tamil'),
          srclang: 'ta',
          country: 'in',
        },
        {
          label: this.$i18next.t('message.pages.videoEditModal.languages.swahili'),
          srclang: 'sw',
          country: 'ke',
        },
        {
          label: this.$i18next.t('message.pages.videoEditModal.languages.serbian'),
          srclang: 'sr',
          country: 'rs',
        }
      ]
    },
  },
  methods: {
    getLangCodeBySrcLang(incomingSrclang) {
      return this.langCodes.filter(
        ({ srclang }) => srclang === incomingSrclang
      )[0]
    },
    getPreparedSrcLang(incomingLabel) {
      let finalResult = incomingLabel
      if (
        incomingLabel === 'pt-BR' ||
        incomingLabel === 'pt-br' ||
        incomingLabel === 'pt'
      )
        return 'pt-BR'
      if (incomingLabel.includes('-')) finalResult = incomingLabel.split('-')[0]
      return finalResult.toLowerCase()
    },
    getCountryCodeBySrcLang(srclang) {
      const countryCode = this.langCodes.filter((lang) => {
        return lang.srclang === this.getPreparedSrcLang(srclang)
      })
      if (countryCode.length) {
        return countryCode[0].country
      }
      return ''
    },
  },
}
